/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import { ICommonResponse, ApiType } from '_core/types';
import { isValue, setEntityName } from '_core/util/object';
import CommonResponse from './CommonResponse';
import { ApiException } from '_core/exceptions';
import { Logger } from '../logger';

function generateResponseError(
  pStatusCode: any,
  pErrorCode: any,
  pErrorMessage: any,
  pErrorMetadata?: any,
) {
  let newError = null;
  if (isValue(pStatusCode) && isValue(pErrorCode) && isValue(pErrorMessage)) {
    newError = {
      statusCode: pStatusCode,
      errorCode: pErrorCode,
      errorMessage: pErrorMessage,
      errorMetadata: pErrorMetadata,
    };
  }
  return newError;
}

export default function HandlePromise(
  pPromise: Promise<any>,
  apiType: ApiType,
  isMock: boolean,
  endpoint: string,
): Promise<any> {
  return pPromise
    .then((obAxios: any) => {
      let response = '';
      if (apiType === 'Smiles') {
        response = obAxios.data.data;
      } else {
        response = obAxios.data;
      }

      const defaultResponse: ICommonResponse = {
        statusCode: null,
        errorCode: null,
        errorMessage: null,
        errorMetadata: null,
        response: null,
      };
      return CommonResponse({ ...defaultResponse, statusCode: 200, response });
    })
    .catch((err: any) => {
      if (err.errorCode && err.errorCode === '999') {
        throw new ApiException(err);
      } else {
        let errorAux = err;
        errorAux = validateError(err, apiType, isMock, endpoint);
        throw new ApiException(errorAux);
      }
    });
}

const validateError = (
  error: any,
  apiType: ApiType,
  isMock: boolean,
  endpoint: string,
) => {
  let newError = null;
  try {
    switch (apiType) {
      case 'Smiles':
        newError = errorTypeSmiles(error, isMock, endpoint);
        break;
      case 'Google':
        newError = errorTypeGoogleApi(error);
        break;
      case 'Smiles-Auth0':
        newError = errorTypeAuth0(error);
        break;
      case 'Smiles-Launchdarkly':
        newError = errorTypeLaunchdarkly(error);
        break;
      case 'Smiles-Liferay':
        // TODO implementar o Erro do Liferay
        newError = errorTypeAuth0(error);
        break;
      default:
        break;
    }

    // Caso o erro da API não se satisfaça com o método escolhido,
    // verifica se algum outro método consiga tratar o erro.
    if (!isValue(newError)) {
      const lstFunctionError = getLstFunctionError();
      for (let g = 0; g < lstFunctionError.length; g += 1) {
        newError = lstFunctionError[g](error);
        if (isValue(newError)) {
          g = lstFunctionError.length;
        }
      }
      // Caso nenhum tratamento deu certo, gerar um erro padrão
      if (!isValue(newError)) {
        newError = generateResponseError(
          500,
          0,
          'Nenhum tratamento para esse erro.',
        );
      }
    }
  } catch (e) {
    Logger.error(e);
    newError = generateResponseError(
      500,
      0,
      'Nenhum tratamento para esse erro.',
    );
  }

  return newError;
};

/** Define a Ordem de Execução das funções de tratamento de erro */
const getLstFunctionError = () => [
  errorHttpCode,
  errorTypeBussiness,
  errorTypeAuth0,
  errorTypeGoogleApi,
  errorCommonSystemErrors,
];

/** Erro de Negócio 1
 *  Exemplo => erro : {response : { data : {message : 'Mensagem de Erro'}, status : numerico  }
 * @param pError Axios Config
 */
const errorTypeBussiness = (pError: any) => {
  let statusCode = null;
  let errorCode = null;
  let errorMessage = null;
  let errorMetadata = null;
  try {
    if (isValue(pError.response) && typeof pError.response === 'object') {
      statusCode = pError.response.status;
      if (
        isValue(pError.response.data) &&
        isValue(pError.response.data.message)
      ) {
        errorCode = pError.response.data.code;
        errorMessage = pError.response.data.message;
        errorMetadata = pError.response.config.url;
      }
    }
  } catch (error) {}
  return generateResponseError(
    statusCode,
    errorCode,
    errorMessage,
    errorMetadata,
  );
};

const errorHttpCode = (pError: any) => {
  let statusCode = null;
  let errorCode = null;
  let errorMessage = null;
  let errorMetadata = null;

  try {
    if (isValue(pError.response) && typeof pError.response === 'object') {
      statusCode = pError.response.status;
      errorCode = 0;
      errorMessage = pError.response.statusText;
      errorMetadata = pError.response.config.url;
    }
  } catch (error) {}

  return generateResponseError(
    statusCode,
    errorCode,
    errorMessage,
    errorMetadata,
  );
};

/** Erro de Negócio para Api do Google
 * @param pError Axios Config
 */
const errorTypeGoogleApi = (pError: any) => {
  let statusCode = null;
  let errorCode = null;
  let errorMessage = null;
  try {
    if (isValue(pError.response) && typeof pError.response === 'object') {
      statusCode = pError.response.status;
      if (
        isValue(pError.response.data) &&
        isValue(pError.response.data.error_message)
      ) {
        errorCode = pError.response.data.status;
        errorMessage = pError.response.data.error_message;
      }
    }
  } catch (error) {}
  return generateResponseError(statusCode, errorCode, errorMessage);
};

const errorTypeAuth0 = (pError: any) => {
  let statusCode = null;
  let errorCode = null;
  let errorMessage = null;
  try {
    if (isValue(pError.response) && typeof pError.response === 'object') {
      statusCode = pError.response.status;
      if (
        isValue(pError.response.data) &&
        isValue(pError.response.data.error) &&
        isValue(pError.response.data.error_description)
      ) {
        errorCode = pError.response.data.error;
        errorMessage = pError.response.data.error_description;
      }
    }
  } catch (error) {}
  return generateResponseError(statusCode, errorCode, errorMessage);
};

const errorTypeLaunchdarkly = (pError: any) => {
  let statusCode = null;
  let errorCode = null;
  let errorMessage = null;
  try {
    if (isValue(pError.response) && typeof pError.response === 'object') {
      statusCode = pError.response.status;
      if (isValue(pError.response.data)) {
        const { data } = pError.response;
        errorCode = data.code ? data.code : 0;
        errorMessage = data.message ? data.message : '';
      }
    }
  } catch (error) {}
  return generateResponseError(statusCode, errorCode, errorMessage);
};

/** Erro de Negócio 1
 *  Exemplo => erro : {response : { data : {message : 'Mensagem de Erro'}, status : numerico  }
 * @param pError Axios Config
 */
const errorTypeSmiles = (pError: any, isMock: boolean, endpoint: string) => {
  let statusCode = null;
  let errorCode = null;
  let errorMessage = null;
  let errorMetadata = null;
  const response = pError.response;
  try {
    if (isValue(response) && typeof response === 'object') {
      statusCode = response.status;
      errorMetadata = setEntityName(
        pError.response.config.url.replace(endpoint, ''),
      );

      if (!isMock) {
        if (isValue(pError.response.data)) {
          const { code, message } = pError.response.data;
          errorCode = code ? code : 0;
          errorMessage = message ? message : '';
        }
      } else {
        if (
          isValue(pError.response.data) &&
          isValue(pError.response.data.data)
        ) {
          const { code, message } = pError.response.data.data;
          errorCode = code ? code : 0;
          errorMessage = message ? message : '';
        }
      }
    }
  } catch (error) {}
  return generateResponseError(
    statusCode,
    errorCode,
    errorMessage,
    errorMetadata,
  );
};

/** Erros node
 * https://nodejs.org/api/errors.html
 *
 */
const errorCommonSystemErrors = (pError: any) => {
  let statusCode = null;
  let errorCode = null;
  let errorMessage = null;
  const lstErrors = [
    { code: 'EACCES', description: 'Permissão negada (Permission denied)' },
    {
      code: 'EADDRINUSE',
      description: 'Endereço já em uso (Address already in use))',
    },
    {
      code: 'ECONNREFUSED',
      description: 'Conexão recusada (Connection refused)',
    },
    {
      code: 'ECONNRESET',
      description: 'Conexão redefinida pelo par (Connection reset by peer)',
    },
    { code: 'EEXIST', description: 'Arquivo Existe ((File exists)' },
    { code: 'EISDIR', description: 'É um diretório (Is a directory)' },
    {
      code: 'EMFILE',
      description:
        'Muitos arquivos abertos no sistema (Too many open files in system)',
    },
    {
      code: 'ENOENT',
      description: 'Nenhum arquivo ou diretório (No such file or directory)',
    },
    { code: 'ENOTDIR', description: 'Não é um diretório (Not a directory)' },
    {
      code: 'ENOTEMPTY',
      description: 'Diretório não vazio (Directory not empty)',
    },
    {
      code: 'ENOTFOUND',
      description: 'Pesquisa de DNS falhou (DNS lookup failed)',
    },
    {
      code: 'EPERM',
      description: 'Operação não permitida (Operation not permitted)',
    },
    { code: 'EPIPE', description: '(Broken pipe)' },
    {
      code: 'ETIMEDOUT',
      description: 'Operação Expirada (Operation timed out)',
    },
  ];

  if (isValue(pError.code)) {
    const lstErrorFind = lstErrors.filter(
      (error) => error.code === pError.code,
    );
    if (isValue(lstErrorFind) && isValue(lstErrorFind[0])) {
      statusCode = 999;
      errorCode = lstErrorFind[0].code;
      errorMessage = lstErrorFind[0].description;
    }
  }
  return generateResponseError(statusCode, errorCode, errorMessage);
};
